import { UnrecoverableEventConfig } from '../types'

import { UnrecoverableErrorStore } from './UnrecoverableError.store'

import type { PageSuffix } from '@/constants/errors/suffix'

export const setPageSuffix = (pageSuffix: PageSuffix) =>
  UnrecoverableErrorStore.setState({ pageSuffix })

export const setAnalyticsConfig = (analyticsConfig: UnrecoverableEventConfig) =>
  UnrecoverableErrorStore.setState({ analyticsConfig })
